export default __webpack_public_path__ + "static/media/ibccontact.aec9afc9.gif";